/**
 * account
 */
export default ((cmp, util) => {
	// 保存
	$('#save-btn').click(function() {
		util.checkSession();
		cmp.messageDone('保存しています');
		var fd = new FormData($(this).closest('form').get(0));

		$.ajax({
			type: "POST",
			url: location.pathname,
			dataType: 'json',
			timeout: 20000,
			data: fd,
			processData: false,
			contentType: false
		}).done(function (data) {
			if(data.message) cmp.messageError(data.message);
			if(data.error) {
				cmp.messageCaution(data.error);
				return false;
			}

			cmp.messageDone('', true); // close
			cmp.messageError('', true); // hidden
			return false;

		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.log("jqXHR: " + jqXHR.status); // HTTPステータス取得
			console.log("textStatus: " + textStatus); // タイムアウト、パースエラー
			console.log("errorThrown: " + errorThrown.message); // 例外情報
			util.checkSession(jqXHR);
		});
	});
});
